export const SERVICE_TYPES = {
  normal: "Normal", pm: "PM", special: "Spécial", special_fret: "Spécial frêt",
  depannage: "Dépannage", express: "Express", express_plus: "Express+", shuttle: "Shuttle", feeder: "Feeder",
};
export const QTY_FIELDS = [
  ["del_pckgs", "Colis livrés"], ["del_stops", "Stops livrés"], ["pu_pckgs", "Colis enlevés"], ["pu_stops", "Stops enlevés"],
  ["del_pallets", "Palettes livrées"], ["del_pallet_stops", "Stops palettes livrées"],
  ["pu_pallets", "Palettes enlevées"], ["pu_pallet_stops", "Stops palettes enlevées"],
];
export const RETURN_MOTIFS = [
  "NOT IN 1", "NOT IN 2", "NOT IN 3", "NO MONEY 1", "NO MONEY 2", "NO MONEY 3", "CLOSE 1", "CLOSE 2", "CLOSE 3",
  "NSN", "NSP", "NSS", "REFUSED", "FUTUR", "DAMAGE", "REROUTE", "AUTRE",
];
export const CONTROL_STATES = {
  attente_rapport: "En attente de rapport", ecart: "Écart à résoudre", conforme: "Conforme", validee: "Validée",
};
export const ROLE_LABELS = { admin: "Administrateur", gestionnaire: "Gestionnaire", soustraitant: "Sous-traitant", chauffeur: "Chauffeur" };
export const PRICING_BASES = {
  forfait: "Forfait", pallets: "Palettes (livrées + enlevées)", stops_hors_palettes: "Stops hors stops palettes", total_stops: "Stops totaux",
  del_stops: "Stop livré", del_pckgs: "Colis livré", pu_stops: "Stop enlevé", pu_pckgs: "Colis enlevé",
  del_pallet_stops: "Stop palette livrée", extra_del_pallets: "Palette livrée suppl.", pu_pallet_stops: "Stop palette enlevée",
  extra_pu_pallets: "Palette enlevée suppl.", km: "Kilomètre", hours: "Heure", ups_percent: "% du montant UPS",
};
export const VAT_MODES = {
  a_confirmer: "À confirmer", htva: "Hors TVA", tva: "TVA au taux indiqué", autoliquidation: "Autoliquidation", exonere: "Exonéré",
};
export const TOURE_GROUPS = ["", "TOURE", "JEAN BOSCO", "BILLY", "PIERRE"];

export const emptyQty = () => Object.fromEntries(QTY_FIELDS.map(([k]) => [k, ""]));
export const emptyComponent = (type = "normal") => ({ type, zone: "", qty: emptyQty(), special: { destination: "", address: "", km: "", hours: "", minutes: "" } });
export const currentPeriod = () => new Date().toISOString().slice(0, 7);
